import React, { useEffect, useRef } from "react";

/** Floating ember particles — pure CSS, no deps */
export default function EmberField({ count = 24, className = "" }) {
  const ref = useRef(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.innerHTML = "";
    for (let i = 0; i < count; i++) {
      const d = document.createElement("span");
      d.className = "ember-dot";
      d.style.left = `${Math.random() * 100}%`;
      d.style.animationDuration = `${8 + Math.random() * 10}s`;
      d.style.animationDelay = `${-Math.random() * 10}s`;
      d.style.opacity = `${0.4 + Math.random() * 0.5}`;
      d.style.width = `${2 + Math.random() * 4}px`;
      d.style.height = d.style.width;
      el.appendChild(d);
    }
  }, [count]);
  return (
    <div
      ref={ref}
      aria-hidden="true"
      className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`}
    />
  );
}
